<template>
    <div class="chatting-modal" @click="onClick">
      <a-button v-if="!is_to_friend" type="primary">
        聊天记录
      </a-button>
      <div v-else>
        查看聊天记录
      </div>
      <a-modal
        title="聊天记录"
        :visible="visible"
        :closable="true"
        :centered="true"
        @cancel="handleCancel"
        width="60%"
        style="height: 100px"
      >
        <div v-if="is_to_friend" style="margin-bottom: 10px">
          <a-select notFoundContent="没有找到机器人" optionLabelProp="nickname" v-model="selectedBotUsername" @change="fetch" style="width: 400px; margin-left: auto; margin-right: auto" :autoFocus="true">
            <a-select-option :key="bot.username" :nickname="bot.nickname" v-for="bot in bot_list">
              <div class="avatar-36-con">
                <img class="avatar" :src="bot.avatar_url"/>
                <div class="nickname">{{bot.nickname + (bot.username ? '（' + bot.username + '）' : '')}}</div>
              </div>
            </a-select-option>
          </a-select>
        </div>
        <a-button slot="footer" type="primary" @click="handleCancel">
          关闭
        </a-button>
        <div v-if="chattings !== null && chattings !== undefined && chattings.length === 0">
          没有聊天记录
        </div>
        <div v-else style="height: 800px; overflow-y: auto">
          <!--{{ this.chattings.length }}-->
          <div v-for="msg in chattings" :key="msg.msg_id" style="max-width: 100%;">
            <span style="display: flex;justify-content: space-between;align-items: center">
              <span class="avatar-36-con">
                <img class="avatar" :src="msg.talker_info.avatar_url"/>
                <div class="nickname">{{msg.talker_info.nickname + '（' + msg.talker_info.username + '）'}}</div>
              </span>
              <span style="min-width: 200px"> {{ msg.create_time }}</span>
            </span>
            <a-card :bodyStyle="{ maxWidth: 100 + '%', padding: '8px 16px 8px 16px' }" type="inner" :loading="cardLoading" style="max-width: 95%; display: inline-flex; border: 1px solid #dadada; border-radius: 10px; margin: 5px 0 10px 0">
              <div v-if="msg.type === 1"> {{ msg.real_content }} </div>
              <!--<div v-if="msg.type === 1"> {{ msg.real_content }} </div>-->
            </a-card>
          </div>
        </div>
      </a-modal>
    </div>
</template>

<script>
import AButton from 'ant-design-vue/es/button/button'
const axios = require('axios')
export default {
  name: 'ChattingModal',
  components: {AButton},
  props: ['dataIndex', 'is_to_friend', 'bot_list'],
  data () {
    console.log('this.bot_list', this.bot_list)
    return {
      getChattingsUrlPostFix: 'UChatroom/get_chattings',
      visible: false,
      cardLoading: false,
      chattings: null,
      selectedBotUsername: (this.bot_list !== undefined && this.bot_list.length > 0) ? this.bot_list[0].username : ''
    }
  },
  computed: {
    getChattingsUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getChattingsUrlPostFix
    }
  },
  watch: {
    dataIndex: function (newValue, oldValue) {
      this.chattings = null
    }
  },
  methods: {
    onClick () {
      this.visible = true
      if (this.chattings === null) {
        this.fetch()
      }
    },
    handleCancel () {
      this.visible = false
    },
    fetch () {
      this.cardLoading = true
      axios.post(this.getChattingsUrl, {
        talker: this.dataIndex,
        is_to_friend: this.is_to_friend,
        bot_username: this.selectedBotUsername,
        // chatroomname: '12540001951@chatroom',
        page: 1,
        page_size: 50,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            let chattingList = data.data.content.chatting_list
            let dataList = []
            chattingList.forEach((item) => {
              // let talkerInfo = {
              //   avatar_url: item.avatar_url,
              //   nickname: item.nickname || '',
              //   username: item.username
              // }
              // let deviceId = item.device_id || '-'
              // let isAlive = item.is_alive || false
              // let remark = item.remark || '-'
              // let createTime = item.create_time
              dataList.push({
                // base_info: baseInfo,
                // device_id: deviceId,
                // is_alive: isAlive,
                // remark: remark,
                ...item,
                create_time: this.transform(item.create_time, 'yyyy-MM-dd hh:mm:ss')
              })
            })
            this.cardLoading = false
            // console.log('dataList', dataList)
            this.chattings = dataList
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    transform (value, fmt, ...args) {
      if (typeof value === 'number') {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11) value *= 1000

        let date = new Date(value)
        var o = {
          'M+': date.getMonth() + 1, // 月份
          'd+': date.getDate(), // 日
          'h+': date.getHours(), // 小时
          'm+': date.getMinutes(), // 分
          's+': date.getSeconds(), // 秒
          'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay()
        }
        var weekMap = [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ]
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt) && k !== 'W') {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
          }
          if (new RegExp('(' + k + ')').test(fmt) && k === 'W') {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]])
          }
        }
        return fmt
      } else return ''
    }
  }
}
</script>

<style scoped>

</style>
